import { useErrorCasesOverviewViewModel } from "./useErrorCasesOverviewViewModel";
import { FormsOverviewComponent } from "../FromsOverview/FormsOverview.component";

export function ErrorCasesOverviewScreen() {
    const vm = useErrorCasesOverviewViewModel();
    return <FormsOverviewComponent {...vm} />;
}
